import {IconProps} from 'src/types/icon';

export const IconArrowForward = (props: IconProps): JSX.Element => (
  <svg className={props.className} width={props.width} height={props.height} viewBox="0 0 12.004 23.004" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.002 1l10 9.879zm0 21l10-11.021z" fill={props.fill} stroke={props.fill} strokeLinejoin="round" strokeWidth="2" />
  </svg>
);
